export const STATUS_LABELS = {
    NEW: 'Nuevo',
    OPEN: 'Abierto',
    IN_PROGRESS: 'En progreso',
    PENDING_CUSTOMER: 'Espera cliente',
    PENDING_THIRD_PARTY: 'Espera tercero',
    RESOLVED: 'Resuelto',
    CLOSED: 'Cerrado',
    CANCELLED: 'Cancelado',
};

export const SOURCE_LABELS = {
    PORTAL: 'Portal',
    EMAIL: 'Email',
    PHONE: 'Teléfono',
    CHAT: 'Chat',
    API: 'API',
    INTERNAL: 'Interno',
};

export const PRIORITY_LABELS = {
    LOW: 'Baja',
    MEDIUM: 'Media',
    HIGH: 'Alta',
    URGENT: 'Urgente',
    CRITICAL: 'Crítica',
};

export const TYPE_LABELS = {
    INCIDENT: 'Incidente',
    REQUEST: 'Solicitud',
    PROBLEM: 'Problema',
    CHANGE: 'Cambio',
    TASK: 'Tarea',
};

export const QUICK_RANGE_OPTIONS = [7, 15, 30, 60, 90].map((value) => ({
    value,
    label: `Últimos ${value} días`,
}));

export const FILTER_STATUS_OPTIONS = [
    { value: '', label: 'Todos' },
    ...Object.keys(STATUS_LABELS).map((key) => ({ value: key, label: STATUS_LABELS[key] })),
];

export const FILTER_PRIORITY_OPTIONS = [
    { value: '', label: 'Todas' },
    ...Object.keys(PRIORITY_LABELS).map((key) => ({ value: key, label: PRIORITY_LABELS[key] })),
];

export const FILTER_TYPE_OPTIONS = [
    { value: '', label: 'Todos' },
    ...Object.keys(TYPE_LABELS).map((key) => ({ value: key, label: TYPE_LABELS[key] })),
];

export const FILTER_SOURCE_OPTIONS = [
    { value: '', label: 'Todos' },
    ...Object.keys(SOURCE_LABELS).map((key) => ({ value: key, label: SOURCE_LABELS[key] })),
];

export const FILTER_SLA_MODE_OPTIONS = [
    { value: '', label: 'Todos' },
    { value: 'OVERDUE_OPEN', label: 'Vencidos abiertos' },
    { value: 'BREACHED_RESOLVED', label: 'Resueltos fuera de SLA' },
];

export const EMPTY_ASSIGNEE_OPTIONS = [{ value: '', label: 'Todos' }];

export const createEmptyDashboard = () => ({
    summary: {
        totalTickets: 0,
        openTickets: 0,
        resolvedTickets: 0,
        overdueOpenTickets: 0,
        breachedResolvedTickets: 0,
        avgFirstResponseHours: 0,
        avgResolutionHours: 0,
    },
    previousSummary: {
        totalTickets: 0,
        openTickets: 0,
        resolvedTickets: 0,
        overdueOpenTickets: 0,
        breachedResolvedTickets: 0,
    },
    variation: {
        totalTickets: 0,
        openTickets: 0,
        resolvedTickets: 0,
        overdueOpenTickets: 0,
        breachedResolvedTickets: 0,
    },
    tickets: {
        byStatus: [],
        byPriority: [],
        byType: [],
        bySource: [],
        createdTrend: [],
        resolvedTrend: [],
        openAging: [],
        topAssignees: [],
    },
});
